// Errors for validation
const ValidationErrors = Object.freeze({
  tel: 'Bitte geben Sie eine gültige Mobilnummer ein. (+49123456789)',
  email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  iban: 'Bitte geben Sie eine gültige IBAN ein.',
  bic: 'Bitte geben Sie einen gültigen BIC ein.',
});

export default ValidationErrors;
